module.exports = __webpack_public_path__ + "static/media/clock-regular.96e82a48.svg";